import { render, staticRenderFns } from "./terms-modal.vue?vue&type=template&id=2aea014c&"
import script from "./terms-modal.vue?vue&type=script&lang=ts&"
export * from "./terms-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports